import { type ListarMensajesLicitacionesResponse, type MensajeLicitacion } from './api.schema';
import { type ListarMensajesLicitacionesUi } from './ui.schema';

export { 
  ListarMensajesLicitacionesResponseSchema,
  type ListarMensajesLicitacionesResponse,
  type MensajeLicitacion
} from './api.schema';

export { 
  ListarMensajesLicitacionesUiSchema,
  type ListarMensajesLicitacionesUi
} from './ui.schema';

export const transformMensajesLicitacionesApiToUi = (
  response: ListarMensajesLicitacionesResponse
): ListarMensajesLicitacionesUi => {
  return response.map((mensaje: MensajeLicitacion) => ({
    id: mensaje.id || '',
    fecha_creacion: mensaje.fecha_creacion || '',
    mensaje: mensaje.mensaje || '',
    usuario_autor: mensaje.usuario_autor || '',
    activo: mensaje.activo || false
  }));
}; 